import React from "react";
import { Link } from "react-router-dom";
import img1 from "../../../assets/images/home_page_4/deals/01.png";
import img2 from "../../../assets/images/home_page_4/deals/02.png";
import img3 from "../../../assets/images/home_page_4/deals/03.png";

const categories = [
    { id: 1, img: img2, title: "Computers & Laptop", items: 6 },
    { id: 2, img: img3, title: "Mobiles & Tablets", items: 6 },
    { id: 3, img: img1, title: "Game & Accessories", items: 6 },
    { id: 4, img: img2, title: "Camera & Photo", items: 6 },
    { id: 5, img: img3, title: "Electronics & Digital", items: 6 },
    { id: 6, img: img1, title: "Audio & Headphone", items: 6 },
];

const ShopCategory = () => {
    return (
        <section id="shop-category" className="shop-category-main-block">
            <div className="container">
                <div className="deals-product-border">
                    <div className="row">
                        <div className="col-lg-4 col-md-5">
                            <div className="section">
                                <h3 className="section-heading-first">Shop By Categories</h3>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7">
                            <p className="shop-category-des">
                                No handling fees + free shipping on orders over $35*
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {categories.map((category) => (
                        <div key={category.id} className="col-lg-2 col-md-4">
                            <div className="deals-product-block text-center">
                                <div className="deals-product-img">
                                    <Link to="#" title="">
                                        <img src={category.img} className="img-fluid" alt={category.title} />
                                    </Link>
                                </div>
                                <div className="deals-product-dtls">
                                    <h6 className="deals-product-heading">
                                        <Link to="#" title="">{category.title}</Link>
                                    </h6>
                                    <p>{category.items} Items</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ShopCategory;
